import { AlertTriangle, Loader2 } from "lucide-react";
import { ACTIVE, PHASES } from "@/lib/jammableApi";

/** Running / failed Jammable voice changes of this track's takes (finished ones simply appear as new takes). */
export default function TakeRevoiceStatus({ jobs, trackId }) {
  const mine = jobs.filter((j) => j.track_id === trackId && (ACTIVE.includes(j.status) || (j.status === "error" && Date.now() - Date.parse(j.updated_at) < 30 * 60 * 1000)));
  if (!mine.length) return null;
  return (
    <ul data-testid="rec-revoice-status" className="mt-3 space-y-1.5">
      {mine.map((j) => (
        <li key={j.id} data-testid={`rec-revoice-${j.id}`} data-status={j.status} className="flex items-center gap-2 rounded-xl border border-fuchsia-300/20 bg-fuchsia-500/[0.07] px-3 py-2 text-[12px]">
          {j.status === "error" ? <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-rose-300" /> : <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-fuchsia-200" />}
          <span className="font-semibold">{j.take_name} → {j.voice?.name}</span>
          <span className={j.status === "error" ? "text-rose-200" : "text-white/60"}>
            {j.status === "error" ? j.error : `${PHASES[j.status]}${j.status === "converting" && j.progress ? ` · ${j.progress}%` : "…"}`}
          </span>
        </li>
      ))}
    </ul>
  );
}
